import React from 'react'
import { t } from '../../utils/markets'
import { nonWallMountLabel } from '../../utils/market-aircon-booking'
import { PriceTable } from './ui'

// Every aircon price for a market in plain tables - the body of the
// "AC service price" / "aircond service price" pages. Same numbers as the
// bookable tiles (both come from js/aircon-cost buildAirconPriceTables).
export const AirconFullPriceTables = ({ market, tables }) => {
    const cd = market.countryCd
    const other = nonWallMountLabel(market)
    const unitsLabel = (n) => `${n} unit${n > 1 ? 's' : ''}`

    return (
        <div className="space-y-8">
            <PriceTable
                countryCd={cd}
                caption={`${t(market, 'acGeneral')} - one visit`}
                columns={[
                    { key: 'units', label: 'Units' },
                    { key: 'wall', label: t(market, 'mountWall') },
                    { key: 'ducted', label: other },
                    { key: 'perUnitWall', label: `Per unit (${t(market, 'mountWall').toLowerCase()})` },
                ]}
                rows={tables.general.map((r) => ({ ...r, units: unitsLabel(r.units) }))}
                moneyKeys={['wall', 'ducted', 'perUnitWall']}
            />
            <PriceTable
                countryCd={cd}
                caption={t(market, 'acChemicalWash')}
                columns={[
                    { key: 'units', label: 'Units' },
                    { key: 'wall', label: t(market, 'mountWall') },
                    { key: 'ducted', label: other },
                ]}
                rows={tables.chemicalWash.map((r) => ({ ...r, units: unitsLabel(r.units) }))}
                moneyKeys={['wall', 'ducted']}
            />
            <PriceTable
                countryCd={cd}
                caption={t(market, 'acChemicalOverhaul')}
                columns={[
                    { key: 'units', label: 'Units' },
                    { key: 'wall', label: t(market, 'mountWall') },
                    { key: 'ducted', label: other },
                ]}
                rows={tables.chemicalOverhaul.map((r) => ({ ...r, units: unitsLabel(r.units) }))}
                moneyKeys={['wall', 'ducted']}
            />
            <PriceTable
                countryCd={cd}
                caption={`${t(market, 'acAnnual')} - price per year`}
                columns={[
                    { key: 'units', label: 'Units' },
                    { key: 'threeTimes', label: '3 visits a year' },
                    { key: 'fourTimes', label: '4 visits a year' },
                ]}
                rows={tables.annual.map((r) => ({ ...r, units: unitsLabel(r.units) }))}
                moneyKeys={['threeTimes', 'fourTimes']}
            />
            <PriceTable
                countryCd={cd}
                caption={`${t(market, 'acGas')} - per outdoor unit`}
                columns={[
                    { key: 'refrigerant', label: 'Refrigerant' },
                    { key: 'half', label: 'Top-up' },
                    { key: 'full', label: 'Full refill' },
                ]}
                rows={Object.entries(tables.gas).map(([refrigerant, v]) => ({ refrigerant, ...v }))}
                moneyKeys={['half', 'full']}
            />
            <PriceTable
                countryCd={cd}
                caption="Other services"
                columns={[
                    { key: 'service', label: 'Service' },
                    { key: 'price', label: 'Price' },
                ]}
                rows={[
                    { service: 'Repair diagnosis visit', price: tables.repairDiagnosis },
                    { service: 'Outdoor unit (condenser) cleaning, 1 unit', price: tables.condenser[0].normal },
                    { service: 'Outdoor unit chemical cleaning, 1 unit', price: tables.condenser[0].chemical },
                    { service: 'Drain pipe flush, 1 unit', price: tables.drainFlush[0].price },
                ]}
                moneyKeys={['price']}
            />
        </div>
    )
}
